export default __webpack_public_path__ + "static/media/memoseq_responsive.056b65fe.png";